import { inject, Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  isUserSignup: boolean = false;

  private route: Router = inject(Router);
  private dialog: MatDialog = inject(MatDialog);

  constructor() {}

  /**
   * @description this method is used to navigate to selected page
   * @param path
   * @param paramValue param values
   */
  goTo(path: string, extras: NavigationExtras = {}): void {
    this.route.navigate([path], extras);
  }

  /**
   * @description this method is used to show success/failure message.
   * @param arg is an object which holds type and message.
   */
  popUp(type: string, message: string, yes?: string, no?: string) {
    return this.dialog.open(DialogOverviewComponent, {
      data: {
        type: type,
        message: message,
        yes: yes || 'Yes',
        no: no || '',
      },
    });
  }

  openTermsCondition() {
    window.open('https://hey-kiddo.com/heykiddo-app-terms', '_blank');
  }

  getQueryParams(paramName: string): string {
    const urlSearch = new URLSearchParams(window.location.search);
    return urlSearch.get(paramName);
  }

  getHeaderOptions(token: string): { headers: HttpHeaders } {
    const headersObj = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headersObj['Authorization'] = `Bearer ${token}`;
    }
    const headers = new HttpHeaders(headersObj);
    return { headers };
  }
}
